import { Observable } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';

import { DataStoreOptions, ItemOfflineDataFetcher, SearchResponse } from '@skinsoft/data-store';
import { API_ENDPOINTS, Expression, Manifestation, Work } from '@skinsoft/entity';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { searchResultSelectors, wemiSelectors } from '@skinsoft/search-data-store';
import { Wemi, WemiUtils } from '../wemi-utils';

export type SearchResult = Item & Manifestation & Expression & Work;

declare var ITEM_SEARCH_TYPES: string[];

export interface Item {
    id: string;
    identificationItemSchema: {
        barCodes: {
            translatedString: {
                fr: string;
            };
        };
    };
    associatedMedias: any
    stateItemSchema: any
    type: string
    linkToManifestation: {
        referentManifestation: string
    }

}

export class ItemDataStore extends EntityDataStore<Item, any, SearchResult | Wemi> {
    public static getInstance() {
        if (!ItemDataStore.instance) {
            ItemDataStore.instance = new ItemDataStore();
        }

        return ItemDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$itemDataStore = ItemDataStore.getInstance();
    }

    public static getItemSearchResultId(itemSearchResult: SearchResult | Wemi) {
        if ("id" in itemSearchResult) {
            return searchResultSelectors.id(itemSearchResult);
        } else {
            return wemiSelectors.id(itemSearchResult);
        }
    }

    private static instance: ItemDataStore = null as any;

    constructor() {
        super('items', ITEM_SEARCH_TYPES);
    }

    public searchAll(queryText: string | null, sortObject: any, pageSize: number = 15, types?: string[], page: number = 0, advancedSearches: any = null, filteredIds?: string[], pathAndValueToCheck?: any, searchEndpointOverride: string | null = null, options: DataStoreOptions = {})
        : Observable<SearchResponse<SearchResult | Wemi>> {
        return super.searchAll(queryText, sortObject, pageSize, types, page, advancedSearches, filteredIds, pathAndValueToCheck, searchEndpointOverride, options);
    }


    public update(id: string, body: Partial<Item>, endpointOverride?: string): Observable<Item> {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string])
    }

    public getWemiFromItem(itemId: string): Observable<Wemi> {
        return WemiUtils.getWemiFromItem(itemId)
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ItemOfflineDataFetcher(this.sanitizedIdentifer);
    }
}
